exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-match-container{z-index:-599;width:100%;height:100vh;-ms-flex-pack:center;-ms-flex-align:center;-ms-flex-direction:column;flex-direction:column}.no-match-container,.no-match-inner-container{display:-ms-flexbox;display:flex;justify-content:center;align-items:center}.no-match-inner-container{-ms-flex:1;flex:1;-ms-flex-pack:center;-ms-flex-align:center;-ms-flex-direction:column;flex-direction:column}.no-match-inner-container .no-match-logo-container{width:80%;-ms-flex-pack:center;justify-content:center}.no-match-inner-container .no-match-logo-container a .logo{width:100%;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/nomatch.styl
// module id = 497
// module chunks = 0